import React, { ReactElement } from "react";
import Content from "./Content";

export default function Heading(props: any): ReactElement {
  const { children, align, type } = props;
  const Tag = type;
  return (
    <Tag style={{ ...(align && { textAlign: align }), marginBottom: "10px" }}>
      <Content contentValue={children} />
    </Tag>
  );
}
